import {deleteById} from "../../../api/endpoints/CrudApi";

export async function deleteEntity(path: string, entity: any) {
    if (entity.id) {
        return await deleteById(path, entity.id).then((res) => {
            return res.status === 200;
        });
    }
    return false;
}